import { useContext } from 'react'

import Modal from '@/components/view/layouts/modal/Modal'
import ModalHeader from '@/components/view/molecules/modal/ModalHeader'

import PasswordForm from '@/components/container/form/modules/admin/password/PasswordForm'

import { PasswordModalContext } from './PasswordModalProvider'

const PasswordModal = () => {
  const { modal, showing, hide } = useContext(PasswordModalContext)

  return (
    <Modal show={showing}>
      <ModalHeader text={'パスワード変更'} onClickClose={hide} />
      {modal.showing && <PasswordForm hide={hide} />}
    </Modal>
  )
}

export default PasswordModal
